'use strict';
import React from 'react';
import * as ReactDOM from 'react-dom';
import '@/less/_reset.less';
import { fontSize } from '@/lib/utils';
import Container from './container';
fontSize(375, 100);
var App = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(Container, null)));
};
var app = document.getElementById('app');
ReactDOM.render(React.createElement(App, null), app);
